import { Typography, Grid } from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ArticleIcon from "@mui/icons-material/Article";
import { styles, iconStyle } from "./glossaryData.styles";

const iconFile = <ArticleIcon style={iconStyle} />;
const iconEye = <RemoveRedEyeIcon style={iconStyle} />;

export const iccGlossaryData = (t) => ({
  rows: [
    {
      parameter: "name",
      detail: "complete_name_patient",
      behavior: "-",
      align: { behavior: "center" },
    },
    {
      parameter: "antiquity",
      detail: "time_elapsed_enrollment",
      behavior: "-",
      align: { behavior: "center" },
    },
    {
      parameter: { text: "FEVI", subtext: "left_ventricular_ejection_fraction" },
      detail: "obtained_from_patient_table",
      behavior: (
        <Typography sx={styles.cells}>
          • {t("no_data")}= "--" <br />
          {t("with_data_indicate_%")}:
          <br />• {t("with_data_minor")} 🟡
          <br />• {t("with_data_elderly")} 🟢
        </Typography>
      ),
    },
    {
      parameter: "amount_drugs",
      detail: "analyzes_groups_drugs",
      behavior: (
        <Typography sx={styles.cells}>
          <br /> • {t("value_groups_patient_drugs")}:
          <br /> • {t("if_not_use_drugs")}
          <br /> • {t("if_have_drugs_group_1")}
          <br /> • {t("if_have_drugs_group_2")}
          <br /> • {t("if_have_drugs_group_3")}
          <br /> • {t("if_have_drugs_group_4")}
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "weekly_adherence",
      detail: "reported_as_percentage",
      behavior: (
        <Typography sx={styles.cells}>
          {t("load_percentage")}
          <br />• {t("if_load_porcentage_elderly_70")} "
          <span style={styles.success}>75%</span>"
          <br />• {t("if_porcentage_elderly_40")} "
          <span style={styles.warning}>60</span>%"
          <br />• {t("if_porcentage_minor_40")}
          <span style={styles.error}> 35</span>%" <br />
          {t("example")}"🟢<span style={styles.success}> 71</span>%"
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "last_load",
      detail: "last_charge_time",
      behavior: (
        <Typography sx={styles.cells}>
          • {t("no_data_last_two_month")}{" "}
          <span style={styles.error}>{t("greater_than_two")}</span> <br />•
          {t("if_load_al_least_one")}
          <span style={styles.success}>{t("sixteen_hours")}</span> • <br />
          {t("if_load_more_than_two_days")}
          <span style={styles.error}>{t("four_days")}</span> <br />
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: { text: "fc_today", subtext: "frequency_today" },
      detail: "show_fc",
      behavior: (
        <Typography sx={styles.cells}>
          • {t("no_data")}: -- <br />
          {t("with_data_porcentage_color")} <br />• {t("if_data_larger_than_fifty")} "
          <span style={styles.success}>65</span>" <br />•
          {t("data_minor_than_fifty")}"
          <span style={styles.error}>95</span>"
        </Typography>
      ),
      align: { behavior: "justify" },
    },
    {
      parameter: {
        text: "ta_weekly_average",
        subtext: "tension_weekly_average",
      },
      detail: (
        <Typography sx={styles.cells}>
          {t("show_ta_weekly_average")} ({t("ta_ssystolic_average")})
        </Typography>
      ),
      behavior: (
        <Typography sx={styles.cells}>
          • {t("no_data")}: -- <br />• {t("with_data_ta_systolic_diastolic")}
          <br />• {t("values_the_values_contrasted")} <br />•
          {t("average_within_range")}({t("particular_patient")}):{" "}
          <span style={styles.error}>95 / 70</span> <br />•
          {t("average_without_range")}:{" "}
          <span style={styles.error}>150 / 115</span>
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "face_today",
      detail: "show_represetative_face",
      behavior: (
        <Typography sx={styles.cells}>
          • {t("no_data")}:⚪️ <br />• {t("have_registration_day")}
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "alert_yellow",
      detail: "upload_data_today",
      behavior: (
        <Typography sx={styles.cells}>
          <br />• {t("not_upload")}:⚪️
          <br />• {t("loading_today_havent_yellow_alerts")}🟢
          <br />• {t("loading_today_have_yellow_alerts")} 🟡
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "red_alert",
      detail: "if_loading_one_data_yellow_alarm",
      behavior: (
        <Typography sx={styles.cells}>
          <br />• {t("not_upload")}⚪️
          <br />• {t("upload_today_nothave_redalerts")}🟢
          <br />• {t("upload_today_have_redalerts")}🔴
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
    {
      parameter: "actions",
      detail: (
        <Typography sx={styles.cells}>
          <Grid container direction="column" spacing={8}>
            <Grid item xs={6}>
              {t("see")}
              {iconEye} : {t("allows_you_see")}
            </Grid>
            <Grid item xs={6}>
              {t("health_data")}
              {iconFile}: {t("allows_add_health_data")}
            </Grid>
          </Grid>
        </Typography>
      ),
      behavior: (
        <Typography sx={styles.cells}>
          <Grid container direction="column" spacing={8}>
            <Grid item xs={6} align="justify">
              {t("select_icon_ayes_redirect")}
            </Grid>

            <Grid item xs={6} align="justify">
              {t("select_icon_data_health_show_modify_info")}
            </Grid>
          </Grid>
        </Typography>
      ),
      align: { detail: "justify", behavior: "justify" },
    },
  ],
  footerNote: "icc_glossary_footer_note",
});
